<template>
  <el-row type="flex" justify="center" :gutter="10">
    <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="12">
      <!--div class="s-banner"></div -->
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <PageTitle title="Calculadora de Frete" subtitle="Faça suas cotações" />
        </div>
        <CalculateForm :userType="userType" :result-in-modal="true" @change="change"
          @result="$refs.resultDialog.open()" />
        <CalculateResultDialog ref="resultDialog" />
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="20" :md="16" :lg="8" :xl="6">
      <CalculateUpload :userType="userType" :customer="customer" />
    </el-col>
  </el-row>
</template>

<script>
import PageTitle from '../../layout/PageTitle.vue';
import CalculateForm from './calculate/CalculateForm.vue';
import CalculateResultDialog from './calculate/CalculateResultDialog.vue';
import CalculateUpload from './calculate/CalculateUpload.vue';
import { UserService } from "@/services/users/user.services";

export default {
  name: 'CalculatePage',
  components: {
    PageTitle,
    CalculateForm,
    CalculateResultDialog,
    CalculateUpload,
  },
  data() {
    return {
      userType: '1',
      customer: '',
    }
  },
  methods: {
    change(customer) {
      this.customer = customer;
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.userType = user.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  }
}
</script>

<style scoped>
.s-banner {
  width: 100%;
  height: 100%;
  background: url(../../../../public/img/background-home.png) no-repeat;
  background-position: 50% 50%;
  background-size: 400%;
  position: absolute;
  background-blend-mode: overlay;
  opacity: 0.5;
}

</style>
